import React from "react";
import "../css/my style.css";



export default function ButtonNext() {
    return (
        <button className="next" style={{display: "flex", flexDirection: "row"}}>Next&raquo;</button>
    )
}